import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams, useSearchParams } from "react-router-dom";
import {
  snapDraftBailiffDetail,
  unSnapDraftBailiffDetail,
} from "store/bailiff/draft/bailiff/draft_bailiff.action";
import {
  snapDraftDialog,
  unSnapDraftDialog,
} from "store/bailiff/draft/dialog/draft_dialog.action";
import {
  snapDraftDialogEdited,
  snapDraftDialogEditedComments,
  snapDraftDialogEditedSpeakers,
  unSnapDraftDialogEdited,
  unSnapDraftDialogEditedComments,
  unSnapDraftDialogEditedSpeakers,
} from "store/bailiff/draft/dialog_edited/dialog_edited.action";
import { setHighlight } from "store/bailiff/nav/nav.action";
//
//component
//redux
//selector
//actions
export const TriggerInit = () => {
  // -------------------------- VAR ----------------------------
  const [searchParams] = useSearchParams();
  const tab = searchParams.get("tab") || "not_edit";
  const params = useParams();
  const bailiffId = params.bailiffId;
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  // -------------------------- USE EFFECT ---------------------
  useEffect(() => {
    dispatch(setHighlight(["1"]));
  }, [dispatch]);

  useEffect(() => {
    if (bailiffId) {
      dispatch(snapDraftBailiffDetail({ bailiffId }));
      return () => dispatch(unSnapDraftBailiffDetail());
    }
  }, [bailiffId, dispatch]);

  // snap draft dialog edited
  useEffect(() => {
    if (bailiffId) {
      dispatch(snapDraftDialogEdited({ bailiffId }));
      return () => dispatch(unSnapDraftDialogEdited());
    }
  }, [bailiffId, dispatch]);

  // snap draft dialog edited speakers
  useEffect(() => {
    if (bailiffId) {
      dispatch(snapDraftDialogEditedSpeakers({ bailiffId }));
      return () => dispatch(unSnapDraftDialogEditedSpeakers());
    }
  }, [bailiffId, dispatch]);

  // snap draft dialog edited commpents
  useEffect(() => {
    if (bailiffId) {
      dispatch(snapDraftDialogEditedComments({ bailiffId }));
      return () => dispatch(unSnapDraftDialogEditedComments());
    }
  }, [bailiffId, dispatch]);

  //snap dialog
  useEffect(() => {
    if (bailiffId) {
      dispatch(snapDraftDialog({ bailiffId, tab }));
      return () => dispatch(unSnapDraftDialog());
    }
  }, [bailiffId, dispatch, tab]);
  // -------------------------- RETURN --------------------------
  return <></>;
};
export default TriggerInit;
